<template>
  <div id="theWebSearchUserLoginDiv" class="vld-parent">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />    
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'
import { loginRoutingMixin } from '@/mixins/loginRouting.mixin'

export default {
  name: 'TheWebSearchUserLogin',
  components: {
    Loading,
  },
  mixins: [loginRoutingMixin],
  data: function () {
    return {
      isLoading: true,
      loaderBackgroundColor,
      loaderColor,
    }
  },
  computed: {  
    isSignedIn() { return this.$store.state.common.isSignedIn },
  },
  async beforeCreate() {
    if (this.isSignedIn) {
      await this.$store.dispatch('common/signOut')
    }
  },
  async created() {
    await this.attemptAuth()
    this.initialLoad = false
  },
  methods: {
    async attemptAuth() {
      this.isLoading = true

      const payload = {
        username: this.$route.params.webSearchUserName,
        password: 'pw',
      }

      const loginResult = await this.$store.dispatch('security/authenticateWebSearchLogin', payload)
      let redirectName = 'TheLogin'
      if (loginResult && loginResult.Token) {
        await this.$store.dispatch('mainViews/toggleVasionHome', true)
        await this.routeFromSuccessfulLogin()
        return
      }

      await this.$router.push({ name: redirectName })
    },
    async routeFromSuccessfulLogin() {
      await this.$store.dispatch('admin/getAllUserSettings')
      await this.$store.dispatch('workflow/setCustomFolderView', this.$store.state.workflow.customFolderViewSaved)

      // Check for redirect first, before checking user type
      if (this.$route && this.$route.query && this.$route.query.redirect && this.$route.query.redirect !== '' && this.$route.query.redirect !== '/') {
        this.isLoading = false
        if (this.$route.query.redirect.indexOf('/document/') > -1) {
          this.$router.push({ path: "storage/vaults", query: { redirect: this.$route.query.redirect } })
        } else {
          this.$router.push({ path: this.$route.query.redirect })
        }
        return
      }

      // If no redirect, check for default app
      if (this.defaultApp && this.defaultApp !== '') {
        this.isLoading = false
        // Set the activeSubApp and turn off vasionHome before routing
        this.setActiveSubAppForRoute(this.defaultApp)
        await this.$store.dispatch('mainViews/toggleVasionHome', false)
        this.$router.push({ name: this.defaultAppLocation })
      } else {
        this.isLoading = false
        const firstApp = this.firstAccessibleAppLocation
        if (firstApp) {
          // Determine the app type from the first accessible app route
          const appType = this.getAppTypeFromRoute(firstApp)
          if (appType) {
            this.setActiveSubAppForRoute(appType)
            await this.$store.dispatch('mainViews/toggleVasionHome', false)
          }
          this.$router.push({ name: firstApp })
        } else {
          this.$router.push({ name: 'TheVasionHome' })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
</style>
